import axios from 'axios';
import config from 'config';
import { Effects, loop } from 'redux-loop';
import { finalize } from "actions/URLfinalizer";

import * as a from "actions/user"

const initialState = {
  stage: "nothing",
  respond: {}
};

function inviteUser(inv, successCB, failCB){
  return axios.post(finalize(`${config.api.root}/user/invite`), inv)
    .then((res) => a.inviteUserOk(res, successCB))
    .catch((error) => a.inviteUserFail(error, failCB));
}

export default(state = initialState, action) => {
  switch (action.type) {
    case a.INVITE_USER: {
      return loop (
        Object.assign({}, state, {
          stage: "inviting",
          respond: {}
        }),
        Effects.promise(inviteUser, action.inv, action.successCB, action.failCB)
      )
    }
    case a.INVITE_USER_OK: {
      if (typeof action.successCB == "function") {
        console.log("Okay1")
        action.successCB();
      }
      return Object.assign({}, state, {
        stage: "invited",
        respond: {}
      })
    }
    case a.INVITE_USER_FAIL: {
      console.log(action);
      if (typeof action.failCB == "function") {
        console.log("Okay2")
        action.failCB();
      }
      return Object.assign({}, state, {
        stage: "invite-failed",
        respond: action.e
      })
    }
    case a.RESET_INVITE_STATUS: {
      return Object.assign({}, state, {
        stage: "nothing",
        respond: {}
      })
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user/invite.jsx